import { atom } from 'jotai';

export const turbAtom = atom([
   
  ]);